import * as React from "react";

function SvgMarkettailor(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1356.06 719.03"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>
          {
            ".Markettailor_svg__cls-2{fill:#e1dcb1}.Markettailor_svg__cls-3{fill:#fff}"
          }
        </style>
      </defs>
      <g id="Markettailor_svg__Layer_2" data-name="Layer 2">
        <g id="Markettailor_svg__Logo">
          <path fill="#1e234e" d="M0 0h1356.06v719.03H0z" />
          <path
            className="Markettailor_svg__cls-2"
            d="M934.25 340.17c2.66-.9 5.34-1.78 8.06-2.65q9.44-3 18.55-5.63v1.38s.07 4.73.08 7.14c-.08-.24-.08 79.8-.08 79.8v9h-26.61z"
          />
          <path
            className="Markettailor_svg__cls-3"
            d="M704.58 310.92c9-2.83 17.42-5.55 26.61-8.44v29.41s23.42-.07 28.64 0c0 2.8-.05 1.5-.06 13.68 0 11.35.13 4.52.13 12.93h-28.64v2.1S730 379.49 736 389c3.72 5.85 6.6 10.4 13.4 12.21a98.4 98.4 0 0010.5 1.4c0 3.06.12 23.56-.07 26.61h-7.71a44.86 44.86 0 01-24.06-8.58c-11-8-18.71-18.13-21.42-32.07a104.79 104.79 0 01-2.06-20.39v-48.14z"
          />
          <path
            className="Markettailor_svg__cls-2"
            d="M977 298.24c2.65-.91 5.34-1.8 8.06-2.69q9.42-3.07 18.54-5.71v1.4s.08 4.81.08 7.25c-.08-.25-.08 81-.08 81v49.71H977z"
          />
          <path
            className="Markettailor_svg__cls-3"
            d="M663.38 396.61a22 22 0 01-33-3.23h64.9a48.73 48.73 0 10-12 21zm-15.1-38.11a22 22 0 0117.22 8.27h-34.43a22 22 0 0117.21-8.27zm-228.69-26.61v5.57a48.67 48.67 0 100 86v5.76h26.61v-97.33zm-22.78 70.63a22.06 22.06 0 1122.05-22.06 22.06 22.06 0 01-22.05 22.06z"
          />
          <path
            className="Markettailor_svg__cls-2"
            d="M895.77 331.89v5.57a48.67 48.67 0 100 86v5.76h26.61v-97.33zM873 402.52a22.06 22.06 0 1122-22.06 22.06 22.06 0 01-22 22.06zm276.3-25.36a22 22 0 0121.63-18.7v-26.61c-26.8.09-48.32 19.69-48.32 48.68v48.65c5.86 0 20.76.08 26.61 0V378.1z"
          />
          <path
            className="Markettailor_svg__cls-3"
            d="M487.59 377.16a22.06 22.06 0 0121.64-18.7v-26.61c-26.8.09-48.32 19.69-48.32 48.68v48.65c5.85 0 20.76.08 26.61 0V378.1"
          />
          <path
            className="Markettailor_svg__cls-2"
            d="M769 310.92c9-2.83 17.42-5.55 26.6-8.44v29.41s23.43-.07 28.64 0c0 2.8 0 1.5-.06 13.68 0 11.35.13 4.52.13 12.93h-28.62v2.1s-1.31 18.89 4.74 28.4c3.72 5.85 6.6 10.4 13.39 12.21a98.4 98.4 0 0010.5 1.4c0 3.06.12 23.56-.07 26.61h-7.7a44.89 44.89 0 01-24.07-8.58c-11-8-18.71-18.13-21.42-32.07a105.57 105.57 0 01-2.06-20.39v-48.14z"
          />
          <path
            className="Markettailor_svg__cls-3"
            d="M211.75 379.83c.08-2.11.52-13.62 9.08-18.91a17.89 17.89 0 019.54-2.53c11.41 0 17.65 8.73 18.4 19.84v50.89c5.85 0 20.75.05 26.61 0v-48.69h.05v-1.57c.58-11.47 6.91-20.51 18.58-20.47 11.93 0 18.22 9.55 18.47 21.39h-.07v49.42h26.61v-4.75s0-42.35.07-42.22v-1.8c0-26.79-18.17-48.55-45-48.65a43.12 43.12 0 00-32 13.37 43.1 43.1 0 00-31.66-13.37 44.56 44.56 0 00-18.68 3.9v-3.93l-18.54 5.64-8.07 2.61v89.07h26.6v-48.21c-.01-.11-.01-.5.01-1.03zm404.6-48.01c-3.5 0-10 .05-11.9 0-5.6-.13-24.51 0-24.51 0l-32.91 35V289.8l-8.06 2.69-18.49 5.7v130.96c6.59 0 19.77.07 26.6 0v-23.8l10.51-11.21s-.19.2 3.69 6.17c5.11 7.84 10.12 15.75 15.34 23.51-.13-.27 3.37 5.33 3.37 5.33s19 .15 26.61 0h5.6c-11.54-17.57-24.45-37-35.86-54.42.1-.19 40.01-42.91 40.01-42.91z"
          />
          <path
            className="Markettailor_svg__cls-2"
            d="M1107 358.82l-22.73 14.43a21.82 21.82 0 011.25 7.3 22 22 0 11-19.47-21.9l12.32-24.43a48.71 48.71 0 1028.63 24.6z"
          />
          <path
            className="Markettailor_svg__cls-2"
            d="M1119.6 342.93s-3.45-6.42-11.94-14a64.55 64.55 0 00-15-10.16h-.06l-16.6 33.4a31 31 0 0112.24 11l31.39-20.17z"
          />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgMarkettailor);
